/* KVL Hill Garden Teas — behavior layer */
(function () {
  'use strict';

  /* ── Scroll reveal ─────────────────────────────────────── */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.kvl-reveal:not(.kvl-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kvl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kvl-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Sticky add-to-cart (product pages) ────────────────── */
  function initStickyAtc() {
    var bar = document.querySelector('.kvl-sticky-atc');
    if (!bar) return;
    var anchor = document.querySelector('.product__form-wrapper, form[action*="/cart/add"]');
    if (!anchor) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('kvl-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(anchor);
    var btn = bar.querySelector('[data-kvl-sticky-add]');
    if (btn) btn.addEventListener('click', function () {
      var realBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
      if (realBtn) { realBtn.click(); }
      else { anchor.scrollIntoView({ behavior: 'smooth' }); }
    });
  }

  /* ── Cart concierge ────────────────────────────────────── */
  var STORIES = [
    /*{ q: 'Every tin carries original artwork by Chitran — a fusion of English and Hindu traditions. No two teas look the same.', c: 'The artwork' },*/
    { q: 'Most commercial tea is 12\u201318 months old before it reaches you. Ours travels from estate to your door in 4\u20138 weeks.', c: 'The sourcing' },
    { q: 'I grew up drinking tea made the way my grandmother made it \u2014 from leaves she could trace to a name.', c: 'Prabuddha \u00b7 Founder' },
    { q: 'Inspired by Ardhanarishvara \u2014 two truths held in balance. Single-estate purity, purposeful craft. Always both.', c: 'The philosophy' },
    { q: 'Every single-estate tea traces to one garden, one flush, one harvest window. Nothing hidden, nothing compromised.', c: 'The discipline' }
  ];

  function initConcierge(scope) {
    var root = (scope || document);
    root.querySelectorAll('.kvl-concierge:not([data-kvl-init])').forEach(function (c) {
      c.setAttribute('data-kvl-init', '1');

      /* rotate story */
      var story = c.querySelector('[data-kvl-story]');
      if (story) {
        var pick = STORIES[Math.floor(Math.random() * STORIES.length)];
        story.querySelector('p').textContent = '\u201C' + pick.q + '\u201D';
        story.querySelector('cite').textContent = pick.c;
      }

      /* gift note → cart attributes */
      var giftToggle = c.querySelector('[data-kvl-gift-toggle]');
      var giftWrap = c.querySelector('[data-kvl-gift-area]');
      var giftNote = c.querySelector('[data-kvl-gift-note]');
      if (giftToggle && giftWrap) {
        giftToggle.addEventListener('change', function () {
          giftWrap.style.display = giftToggle.checked ? 'block' : 'none';
          saveGift();
        });
      }
      var t;
      if (giftNote) giftNote.addEventListener('input', function () { clearTimeout(t); t = setTimeout(saveGift, 700); });
      function saveGift() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: {
            'Gift order': giftToggle && giftToggle.checked ? 'Yes' : '',
            'Gift note': giftToggle && giftToggle.checked && giftNote ? giftNote.value : ''
          } })
        }).catch(function () {});
      }

      /* recommendations rail */
      var rail = c.querySelector('[data-kvl-recs]');
      if (rail) loadRecs(rail);
    });
  }

  function loadRecs(rail) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var inCart = cart.items.map(function (i) { return i.product_id; });
      var src = inCart.length
        ? '/recommendations/products.json?product_id=' + inCart[0] + '&limit=8'
        : null;
      var fallback = '/collections/all/products.json?limit=8';
      return fetch(src || fallback)
        .then(function (r) { return r.ok ? r.json() : fetch(fallback).then(function (r2) { return r2.json(); }); })
        .then(function (data) {
          var products = data.products || [];
          if (!products.length && src) {
            return fetch(fallback).then(function (r) { return r.json(); }).then(function (d) { render(d.products || [], inCart); });
          }
          render(products, inCart);
        });
    }).catch(function () { rail.closest('.kvl-concierge__panel').style.display = 'none'; });

    function render(products, inCart) {
      var picks = products.filter(function (p) { return inCart.indexOf(p.id) === -1 && p.variants && p.variants.length; }).slice(0, 4);
      var panel = rail.closest('.kvl-concierge__panel');
      if (!picks.length) { if (panel) panel.style.display = 'none'; return; }
      rail.innerHTML = picks.map(function (p) {
        var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
        var v = p.variants[0];
        var price = (typeof v.price === 'string' ? parseFloat(v.price) : v.price / 100);
        return '<div class="kvl-rec">' +
          '<a href="/products/' + p.handle + '">' +
          (img ? '<img class="kvl-rec__img" src="' + img + '&width=300" alt="" loading="lazy" onerror="this.src=\'' + img + '\'">' : '<span class="kvl-rec__img"></span>') +
          '<span class="kvl-rec__title">' + p.title + '</span>' +
          '<span class="kvl-rec__price">$' + price.toFixed(2) + '</span></a>' +
          '<button type="button" class="kvl-rec__add" data-vid="' + v.id + '">Add to cart</button>' +
          '</div>';
      }).join('');
      rail.querySelectorAll('.kvl-rec__add').forEach(function (b) {
        b.addEventListener('click', function () {
          b.textContent = 'Adding\u2026';
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1 })
          }).then(function () { window.location.href = '/cart'; });
        });
      });
    }
  }

  function boot() {
    document.body.classList.add('kvl');document.body.classList.add('kvl-js');
    initReveal();
    initStickyAtc();
    initConcierge();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* the theme re-renders the ajax cart; re-init when DOM changes */
  var mo = new MutationObserver(function () { initConcierge(); initReveal(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
/* KVL bridge v2: notify app widgets when any product form's variant changes */
(function () {
  var seen = new WeakMap();
  setInterval(function () {
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (input) {
      var last = seen.get(input);
      if (last !== undefined && input.value !== last) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        document.documentElement.dispatchEvent(
          new CustomEvent('variant:changed', { bubbles: true, detail: { variantId: input.value } })
        );
      }
      seen.set(input, input.value);
    });
  }, 250);
})();